import { transformResultToReadable } from './transformTextToReadable';
import { useCallback } from 'react';

export const useTransformResultToReadable = () => {
  return useCallback((result?: string) => transformResultToReadable(result), []);
};
